import { render } from "./file_content_linked_wysiwyg.vue?vue&type=template&id=24d6542d&scoped=true&lang=pug"
import script from "./file_content_linked_wysiwyg.vue?vue&type=script&lang=js"
export * from "./file_content_linked_wysiwyg.vue?vue&type=script&lang=js"

import "./file_content_linked_wysiwyg.vue?vue&type=style&index=0&id=24d6542d&scoped=true&lang=css"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d6542d"]])

export default __exports__